import React from "react";
import { Box, Progress } from "@chakra-ui/react";
import intl from "../utils/intl";

const ConfirmationProgress = (props) => {
	const { message, value, step } = props;

  return (
		<Box>
		{/* {hidden ? <Box></Box> : */}
    <Box
      w="full"
      pb={5}
      mx="auto"
    >
			<Box fontSize={14}>{`${intl.get("step")} ${step}`}</Box>
			<Box fontSize={14} mt={1}>{message}</Box>
      <Progress 
				mt={3}
				size="xs"
				colorScheme={"purple"}
				value={value} 
			/>
    </Box>
		{/* } */}
		</Box>
  );
};

export default ConfirmationProgress;
